import { CardsDataSourceBase } from "../../common/CardsDataSourceBase";
import { YinzCamAPIResponse } from "yinzcam-api";

export class YinzCamAppServerGameWagonWheel extends CardsDataSourceBase {
  protected getApiClassName(): 'ycapi' | 'contentful' {
    return 'ycapi';
  }

  protected processResponse(
    path: string,
    response: YinzCamAPIResponse,
    specData?: { [key: string]: any }
  ): object | any[] {
    const data = response?.data as any;
    const retData = data?.WagonWheels;
    if (!retData) {
      return {};
    }

    return retData;
  }
}